import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ContextMenuTrigger } from 'react-contextmenu';
import { isEqual, cloneDeep } from 'lodash';
import DynamicTree from '../common/DynamicTree/DynamicTree';
import DictionaryTarget from '../common/DynamicTree/DictionaryTarget';
import * as MenuTypesOptions from '../common/MenuTypesOptions';
import FunctionBoxV2 from './FunctionBoxV2';
import { ALL, ACTION_TYPE_QUESTION, USE_QUESTION_TEXT_SELECT,
  USE_QUESTION_TEXT_DESELECT,
} from '../../constants';
import * as dictionaryActions from '../../actions/dictionaryActions';
import { getActionName } from '../../util/trackerUtils';
import { isNielsenStudyPresent } from '../../util/CrosstabUtils';
import SearchComponentV2 from './SearchComponentV2';
import GenericButton from '../common/GenericButton';
import DynamicContextMenu from '../common/DynamicContextMenu';
import Modal from '../common/Modal/Modal';
import AddToDefinition from '../common/AddToDefinition';
import PortalModal from '../common/Modal/PortalModal';

const modalStyle = {
  width: '975px',
  height: '550px',
  left: '13%',
  top: '3%',
};

const addAfterRunCrosstabModalStyle = {
  width: '20%',
  height: 'auto',
  left: '35%',
  top: '20%',
};

class QuestionsV2 extends Component {
  constructor(props) {
    super(props);
    let treedata = [];
    if (
      this.props.loginResponse &&
      this.props.activeAccountId &&
      this.props.moduleStudy
     ) {
      if (this.props.dictionaryTree && this.props.dictionaryTree.data &&
        this.props.dictionaryTree.data.length > 0) {
        treedata = cloneDeep(this.props.dictionaryTree.data)
      } else {
        this.reloadDictionary(this.props.moduleStudy.pn);
      }
    }
    const useQuestionFlag = this.props.useQuestions !== undefined ? this.props.useQuestions : true;
    this.state = {
      targetData: [],
      treedata,
      selectedNode: {},
      useQuestions: useQuestionFlag,
      // option: 'Default',
      selectedTargets: [],
      showSingleBasePopup: false,
    };
    this.updatePartsToShow(useQuestionFlag);
  }

  componentDidMount() {
    if (this.props.moduleStudy && this.props.moduleStudy.pn) {
      this.reloadDictionary(this.props.moduleStudy.pn);
      this.props.dictionaryActions.dictionaryTargetReset();
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.loginResponse &&
      this.props.activeAccountId &&
      nextProps.moduleStudy &&
      (!isEqual(this.props.moduleStudy, nextProps.moduleStudy))
    ) {
      this.reloadDictionary(nextProps.moduleStudy.pn);
      this.props.dictionaryActions.dictionaryTargetReset();
      // this.props.dictionaryActions.getDictionaryTreeLoad(
      //   this.props.loginResponse.data.uid,
      //   this.props.loginResponse.data.token,
      //   this.props.activeAccountId,
      //   nextProps.moduleStudy.pn,
      //   0,
      //   ALL,
      // );
    } else {
      if (
        this.props.dictionaryTree !== nextProps.dictionaryTree &&
        nextProps.dictionaryTree &&
        nextProps.dictionaryTree.status === 200
      ) {
        this.setState({ treedata: [...nextProps.dictionaryTree.data] });
      }
      if (
        this.props.dictionaryTarget !== nextProps.dictionaryTarget &&
        nextProps.dictionaryTarget &&
        nextProps.dictionaryTarget.status === 200
      ) {
        this.setState({ targetData: [...nextProps.dictionaryTarget.data] });
      }
    }
    if ((nextProps.refreshFlag !== this.props.refreshFlag)) {
      this.reloadDictionary(nextProps.moduleStudy.pn);
      this.props.dictionaryActions.dictionaryTargetReset();
    }
    if (!isEqual(this.props.useQuestions, nextProps.useQuestions)) {
      this.setState({ useQuestions : nextProps.useQuestions });
    }
  }

  onFilterMouseUp = e => this.dynamicTree.onFilterMouseUp(e);

  updatePartsToShow = useQuestionFlag => {
    /* This method is to take care to reset partstoshow for modules which support
    composer and dictionary together based on useQuestions */

    if (this.props.moduleAction.setLabelTypeAC !== undefined) {
      const partsToShow = {
        showCat: false,
        showSCats: false,
        showQ: true,
        showA: true,
      };
      if (!useQuestionFlag) {
        partsToShow.showQ = false;
      }
      this.props.moduleAction.setLabelTypeAC(partsToShow);
    }
  }

  handleNodeClicked = (newNode, currentNode, isSearch) => {
    this.setState({
      selectedNode: {
        node: newNode.node,
        keyword: newNode.keyword,
        shortText: newNode.shortText,
        recordType: newNode.rectype,
      },
    });
    if (currentNode.node || currentNode.recno) {
      this.props.dictionaryActions.updateTreeLoad(currentNode);
    }

    if (isSearch) {
      this.props.dictionaryActions.updateTreeLoad(newNode);
      if (newNode.rectype === 'Q') {
        const payload = {
          data: [...newNode.children],
          status: 200,
        };
        this.props.dictionaryActions.dictionaryTargetLoadFromSearch(payload);
      }
    } else {
      this.props.dictionaryActions.updateTreeLoad(newNode);
      if (newNode.rectype === 'Q') {
        this.props.dictionaryActions.getDictionaryTargetLoad(
          this.props.loginResponse.data.token,
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
          this.props.moduleStudy.pn,
          newNode.node,
          ALL,
          null, // selectedNode
          null, // useQuestions
          null, // componentGridCategory
          true // isTargetAnswer
        );
      } else if (!this.props.treeLoadNodesList.includes(Number(newNode.node))) {
        this.props.dictionaryActions.getDictionaryTreeLoad(
          this.props.loginResponse.data.token,
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
          this.props.moduleStudy.pn,
          newNode.node,
          ALL,
        );
      }
    }
  };

  getContextMenuOptions = menuType => {
    if (menuType === 'contextMenu') {
      const crb = MenuTypesOptions.getContextMenuOptions(MenuTypesOptions.CONTEXT_MENU_TYPES.CRB);
      const scratch = MenuTypesOptions
        .getContextMenuOptions(MenuTypesOptions.CONTEXT_MENU_TYPES.SCRATCHONLY);
      let finalMenu = MenuTypesOptions
        .getContextMenuOptions(MenuTypesOptions.CONTEXT_MENU_TYPES.DEFAULT);
      if (this.props.rowColBaseGrid) {
        finalMenu = [...finalMenu, ...crb];
      }
      if (this.props.rightGridList.includes('scratch')) {
        finalMenu = [...finalMenu, ...scratch];
      }
      return finalMenu;
    }
    const finalMenuOptions = {};
    finalMenuOptions.FUNCTIONS = MenuTypesOptions.CONTEXT_MENU_OPTIONS.FUNCTIONS;
    finalMenuOptions.ADD_DEFINITION = MenuTypesOptions.CONTEXT_MENU_OPTIONS.ADD_DEFINITION;
    finalMenuOptions.SELECT_ALL = MenuTypesOptions.CONTEXT_MENU_OPTIONS.SELECT_ALL;

    if (this.props.rowColBaseGrid) {
      finalMenuOptions.MOVE_TO_COLUMNS = MenuTypesOptions.CONTEXT_MENU_OPTIONS.MOVE_TO_COLUMNS;
      finalMenuOptions.MOVE_TO_ROWS = MenuTypesOptions.CONTEXT_MENU_OPTIONS.MOVE_TO_ROWS;
      finalMenuOptions.MOVE_TO_BASES = MenuTypesOptions.CONTEXT_MENU_OPTIONS.MOVE_TO_BASES;
    }
    if (this.props.rightGridList.includes('scratch')) {
      finalMenuOptions.MOVE_TO_SCRATCH = MenuTypesOptions.CONTEXT_MENU_OPTIONS.MOVE_TO_SCRATCH;
    }
    return finalMenuOptions;
  }

  // Context Menu Handlers
  handleContextMenuOptions = option => {
    const contextMenuOptions = this.getContextMenuOptions();
    let breadCrumbValue;
    if (option !== 'Functions...') {
      const breadcrumbList = JSON.parse(window.localStorage.getItem('breadCrumb'));
      breadCrumbValue = breadcrumbList.reverse().join(' > ');
    }
    const selectedKeywords = [];
    const selectedNames = [];
    const tmpDataSmartSearch = {
      expressionFormed: [],
      objectsAdded: [],
      tags: [],
    };
    const dataSmartSearch = [];
    const selectedTargets = this.dictionaryTarget.getSelectedTargets();
    const action = getActionName(ACTION_TYPE_QUESTION, option);
    if (action !== '') {
      this.props.trackerFn({ action, attributes: { expression: selectedTargets } });
    }
    const nielsenPresent = isNielsenStudyPresent(selectedTargets);

    if (selectedTargets.length === 1) {
      selectedTargets.forEach(node => {
      // for (const node of selectedTargets) {
        let keyword = node.keyword;
        if (nielsenPresent && node.rectype === 'N') {
          keyword = `${node.keyword} >= 1`;
        }
        selectedKeywords.push(keyword);
        selectedNames.push(node.shortText);
        tmpDataSmartSearch.expressionFormed.push(node.keyword);
        if (breadCrumbValue) {
          node.breadcrumbs = breadCrumbValue;
        }
        tmpDataSmartSearch.objectsAdded.push(node);
        tmpDataSmartSearch.tags.push(node.shortText);
        dataSmartSearch.push(tmpDataSmartSearch);
      });
    } else {
      selectedTargets.forEach(node => {
      // for (const node of selectedTargets) {
        const tmpDataSmartSearch = {
          expressionFormed: [],
          objectsAdded: [],
          tags: [],
        };
        let keyword = node.keyword;
        if (nielsenPresent && node.rectype === 'N') {
          keyword = `${node.keyword} >= 1`;
        }
        selectedKeywords.push(keyword);
        selectedNames.push(node.shortText);
        tmpDataSmartSearch.expressionFormed.push(node.keyword);
        if (breadCrumbValue) {
          node.breadcrumbs = breadCrumbValue;
        }
        tmpDataSmartSearch.objectsAdded.push(node);
        tmpDataSmartSearch.tags.push(node.shortText);
        dataSmartSearch.push(tmpDataSmartSearch);
      });
    }

    const sampleWeightedParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      productNo: this.props.moduleStudy.pn,
      weightType: this.props.moduleWeigthType.wt,
      divisor: this.props.moduleWeigthType.dv,
      expressionList: selectedKeywords,
      originalNames: selectedNames,
      selectedNames,
    };
    if (this.props.breadcrumbFlag) {
      sampleWeightedParams.objSmartSearchArray = dataSmartSearch;
    }

    switch (option) {
      case contextMenuOptions.FUNCTIONS:
        this.setState({ selectedTargets }, () => this.functionBoxModal.show());
        break;
      case contextMenuOptions.ADD_DEFINITION:
        this.setState({
          addToDefinition: selectedTargets.map(({ shortText, keyword }) => ({
            id: 0,
            name: shortText,
            expression: keyword,
          })),
        });
        this.addToDefinition.show();
        break;
      case contextMenuOptions.SELECT_ALL:
        this.dictionaryTarget.selectAllTargets();
        break;
      case contextMenuOptions.MOVE_TO_COLUMNS:
        sampleWeightedParams.targetGrid = 'ColumnsDataGrid';
        sampleWeightedParams.gridData = this.props.gridData.ColumnsDataGrid
          ? this.props.gridData.ColumnsDataGrid
          : [];
        this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
        break;
      case contextMenuOptions.MOVE_TO_ROWS:
        sampleWeightedParams.targetGrid = 'RowsDataGrid';
        sampleWeightedParams.gridData = this.props.gridData.RowsDataGrid
          ? this.props.gridData.RowsDataGrid
          : [];
        this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
        break;
      // case contextMenuOptions.MOVE_TO_BASES:
      //   sampleWeightedParams.targetGrid = 'BasesDataGrid';
      //   sampleWeightedParams.gridData = this.props.gridData.BasesDataGrid
      //     ? this.props.gridData.BasesDataGrid
      //     : [];
      //   this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
      case contextMenuOptions.MOVE_TO_BASES: {
        if (this.props.isSingleBase && selectedTargets.length === 1) {
          sampleWeightedParams.targetGrid = 'BasesDataGrid';
          sampleWeightedParams.gridData = this.props.gridData.BasesDataGrid
            ? this.props.gridData.BasesDataGrid
            : [];
          this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
        } else if (!this.props.isSingleBase) {
          sampleWeightedParams.targetGrid = 'BasesDataGrid';
          sampleWeightedParams.gridData = this.props.gridData.BasesDataGrid
            ? this.props.gridData.BasesDataGrid
            : [];
          this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
        } else if (this.props.isSingleBase && selectedTargets.length > 1) {
          this.setState({ showSingleBasePopup: true })
        }
        break;
      }
      case contextMenuOptions.MOVE_TO_SCRATCH:
        sampleWeightedParams.targetGrid = 'ScratchDataGrid';
        sampleWeightedParams.gridData = this.props.gridData.ScratchDataGrid
          ? this.props.gridData.ScratchDataGrid
          : [];
        this.props.moduleAction.getSampleWeighted(sampleWeightedParams);
        break;
      default:
        return null;
    }
    return null;
  };

  handleSelectedKeywords = selectedOperator => {
    const selectedTargets = this.dictionaryTarget.getSelectedTargets();
    if (selectedTargets.length > 0) {
      const titlePrefix = this.state.useQuestions
        ? `${this.state.selectedNode.shortText}: `
        : '';
      this.props.handleSelectedKeywords(
        selectedTargets,
        titlePrefix,
        selectedOperator,
      );
    }
  };

  
  callTrackerFn = checked => {
    if (checked) {
      this.props.trackerFn({ action: USE_QUESTION_TEXT_DESELECT });
    } else {
      this.props.trackerFn({ action: USE_QUESTION_TEXT_SELECT });
    }
  }
  
  reloadDictionary(pn) {
    this.props.dictionaryActions.getDictionaryTreeLoad(
      this.props.loginResponse.data.token,
      this.props.loginResponse.data.uid,
      this.props.activeAccountId,
      pn,
      0,
      ALL,
    );
  }

  setUseQuestions = flag => {
    if (this.props.moduleAction.setDictionaryUseQuestions) {
      /* This call will happens to dictionary search modules which support to remeber selection.
         for now only crosstab remebers it, if C&C needs it we need to create respective
         setDictionaryUseQuestions in the action and initial value in store for that module
      */
      this.props.moduleAction.setDictionaryUseQuestions(flag);
    } else {
      this.setState({ useQuestions: flag });
    }
  }

  render() {
    const dictionaryHeight = this.props.noExpressionBox ? '45rem' : '25rem';
    return (
      <div className="questions-wrapper">
        <div className="expanded row">
          <div className="small-12 large-12 columns padding-left-0 padding-right-0 clearfix">
            <SearchComponentV2 moduleStudy={this.props.moduleStudy} refreshFlag={this.props.refreshFlag} />
            <div className="right-options pull-right">
              <input
                id="use-question"
                type="checkbox"
                onClick={() => {
                  this.callTrackerFn(!this.state.useQuestions);
                  // this.setState(prevState => ({ useQuestions: !prevState.useQuestions }));
                  this.setUseQuestions(!this.state.useQuestions);
                }}
                className="large"
                defaultChecked={this.state.useQuestions}
              />
              <label htmlFor="use-question" aria-label="Select Question" className="large">
                Use Question Text Along with Answer Text
              </label>
              <GenericButton
                name="OR"
                btnStyle="button operator-button"
                onBtnClick={() => this.handleSelectedKeywords('OR')}
              />
              <GenericButton
                name="AND"
                btnStyle="button operator-button no-line"
                onBtnClick={() => this.handleSelectedKeywords('AND')}
              />
            </div>
          </div>
        </div>
        <div
          className="expanded row dictionory-grid-wrapper padding-left-0 padding-right-0"
          data-equalizer
        >
          <div
            className="small-6 medium-6 large-6 columns padding-left-0 padding-right-0"
            data-equalizer-watch
          >
            <div className="dictionory-grid margin-bottom-o" style={{ height: dictionaryHeight }}>
              <DynamicTree
                treedata={this.state.treedata}
                onNodeClicked={this.handleNodeClicked}
                ref={dynamicTree => {
                  this.dynamicTree = dynamicTree;
                }}
                useQuestions={this.state.useQuestions}
                tabSelected="questions"
              />
            </div>
          </div>
          <div
            className="small-6 medium-6 large-6 columns padding-left-0 padding-right-0"
            data-equalizer-watch
          >
            <div className="answer-box">
              <div className="dictionory-grid margin-bottom-o" style={{ height: dictionaryHeight }}>
                <ContextMenuTrigger
                  id={MenuTypesOptions.CONTEXT_MENU_TYPES.QUESTIONS}
                  holdToDisplay={-1}
                >
                  <DictionaryTarget
                    ref={node => {
                      this.dictionaryTarget = node;
                      return this.dictionaryTarget;
                    }}
                    targetData={this.state.targetData}
                    handleAnswersPreview={this.props.handleAnswersPreview}
                    selectedTreeNode={this.state.selectedNode}
                    useQuestions={this.state.useQuestions}
                  />
                </ContextMenuTrigger>
                <DynamicContextMenu
                  menuID={MenuTypesOptions.CONTEXT_MENU_TYPES.QUESTIONS}
                  menuOptions={this.getContextMenuOptions('contextMenu')}
                  handleMenuOptions={this.handleContextMenuOptions}
                />
              </div>
            </div>
          </div>
        </div>
        <Modal
          title="Functions"
          ref={node => {
            this.functionBoxModal = node;
            return this.functionBoxModal;
          }}
          dialogStyles={modalStyle}
        >
          <div className="small-12 medium-12 large-12">
            <div className="column row">
              <FunctionBoxV2
                moduleStudy={this.props.moduleStudy}
                selectedTargets={this.state.selectedTargets}
                moveAppendToCodingBox={this.props.moveAppendToCodingBox}
                handleParentHide={() => this.functionBoxModal.hide()}
                noExpressionBox={this.props.noExpressionBox}
                noCRB={!this.props.rowColBaseGrid}
                sampleWeightedValues={this.props.sampleWeightedValues}
                selectedWeightType={this.props.moduleWeigthType}
                moduleColumns={this.props.moduleColumns}
                moduleRows={this.props.moduleRows}
                moduleAction={this.props.moduleAction}
                functionProbabilitiesFlag={this.props.functionProbabilitiesFlag}
                breadcrumbFlag={this.props.breadcrumbFlag}
              />
            </div>
          </div>
        </Modal>
        <Modal
          title="Add to Definition..."
          ref={node => {
            this.addToDefinition = node;
            return this.addToDefinition;
          }}
          dialogStyles={modalStyle}
        >
          <AddToDefinition
            folderName="Untitled"
            newExpressions={this.state.addToDefinition}
            handleHide={() => this.addToDefinition.hide()}
            srcScreen="QuestionsScreen"
            moduleStudy={this.props.moduleStudy}
          />
        </Modal>
        <PortalModal
          isShowing={this.state.showSingleBasePopup}
          hide={() => this.setState({ showSingleBasePopup: false })}
          title="Select Single Base"
          dialogStyles={addAfterRunCrosstabModalStyle}
          onCloseClicked={() => this.setState({ showSingleBasePopup: false })}
        >
          <p>You have selected more than one Base. Please only select one Base at a time</p>
          <GenericButton
            name="OK"
            btnStyle="button display-block margin-auto"
            onBtnClick={() => this.setState({ showSingleBasePopup: false })}
          />
        </PortalModal>
      </div>
    );
  }
}

QuestionsV2.propTypes = {
  handleAnswersPreview: PropTypes.func,
  handleSelectedKeywords: PropTypes.func,
  moveAppendToCodingBox: PropTypes.func,
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      token: PropTypes.string,
      uid: PropTypes.number,
    }),
  }),
  activeAccountId: PropTypes.number,
  moduleStudy: PropTypes.shape({
    pn: PropTypes.number,
    dv: PropTypes.number,
    wt: PropTypes.number,
  }),
  dictionaryTree: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
    status: PropTypes.number,
  }),
  dictionaryAnswerTarget: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  treeLoadNodesList: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  gridData: PropTypes.shape({
    ColumnsDataGrid: PropTypes.arrayOf(PropTypes.object),
    RowsDataGrid: PropTypes.arrayOf(PropTypes.object),
    BasesDataGrid: PropTypes.arrayOf(PropTypes.object),
    ScratchDataGrid: PropTypes.arrayOf(PropTypes.object),
  }),
  dictionaryActions: PropTypes.shape({
    getDictionaryTreeLoad: PropTypes.func,
    updateTreeLoad: PropTypes.func,
    getDictionaryTargetLoad: PropTypes.func,
    dictionaryTargetLoadFromSearch: PropTypes.func,
    dictionaryTargetReset: PropTypes.func,
  }),
  trackerFn: PropTypes.func,
  moduleWeigthType: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
  rightGridList: PropTypes.arrayOf(PropTypes.string),
  noExpressionBox: PropTypes.bool,
  moduleAction: PropTypes.shape({
    getSampleWeighted: PropTypes.func,
    setDictionaryUseQuestions: PropTypes.func,
  }),
  selectedWeightType: PropTypes.shape({}),
  moduleColumns: PropTypes.arrayOf(PropTypes.object),
  moduleRows: PropTypes.arrayOf(PropTypes.object),
  functionProbabilitiesFlag: PropTypes.bool,
  breadcrumbFlag: PropTypes.bool,
  refreshFlag: PropTypes.bool,
  sampleWeightedValues: PropTypes.arrayOf(PropTypes.object),
  isSingleBase: PropTypes.bool,
  rowColBaseGrid: PropTypes.bool,
  dictionaryTarget: PropTypes.shape({
    status: PropTypes.number,
    data: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  partsToShow: PropTypes.shape({}),
  useQuestions: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    dictionaryTree: state.dictionary.dictionaryTree,
    dictionaryTarget: state.dictionary.dictionaryAnswerTarget,
    treeLoadNodesList: state.dictionary.treeLoadNodesList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuestionsV2);
